import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { shellConnectorToken } from '../../../../team-apis/core/shell-connector';
import { PointCloudContentStore } from '../../../state/point-cloud-content-store';

@Component({
  selector: 'h3-edit-panel-toolbar',
  templateUrl: './edit-panel-toolbar.component.html',
  styleUrl: './edit-panel-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditPanelToolbarComponent {
  @Input() isSingleFrameTask = false;
  private readonly store = inject(PointCloudContentStore);
  private readonly shellConnector = inject(shellConnectorToken);

  isReadOnly$ = this.store('readOnly').$;
  isNewEditPanel = this.shellConnector.hasFeatureFlag('new-edit-panel');
}
